import _ from 'lodash'

import { store } from '@atredux/store'
import {
    getSeawardIFrame,
} from '@atredux/selectors/iframeSelector'

import { CrossFrameUtils } from '@amzn/jwo-store-management-platform-components'
import { getStoreInfo, isConfigured } from '@atredux/selectors/storeSelector'
import { ITool } from '@src/redux/slices/toolSlice'
import { RegisteredAssetsProvider, getAssetDomain, PlatformDomain } from '@amzn/jwo-store-management-platform-registration'
import { getDomainFromHostname } from '@utils/EnvironmentUtil'
import { getAssetIconUrl } from '@utils/AssetUrlUtil'

let toolRegistry = {}
const assetsProvider = new RegisteredAssetsProvider()

export async function loadToolRegistrations (): Promise<any> {
    console.log('ATBase: Starting to load tool registrations...')
    const loadPromise = CrossFrameUtils.sendMessageToOtherFrame({
        frame: getSeawardIFrame(store.getState())?.current?.contentWindow,
        message : {
            method: 'associateToolBaseToolRegistration',
            data: { action: 'load' },
        }})

    loadPromise.then((response) => {
        toolRegistry = response
    })
    return loadPromise
}

/**
 * This function sets the tool registrations
 * @param toolRegistrations
 */
export function setToolRegistrations (toolRegistrations) {
    toolRegistry = toolRegistrations

    // Load tools from centralized JWOStoreManagementPlatformRegistration package
    try {
        // Assets are registered under the asset-domain spelling: platform 'test' is
        // registered as 'beta', so passing the platform domain through matches nothing.
        const platformDomain = getDomainFromHostname() as PlatformDomain
        const assetDomain = getAssetDomain(platformDomain) || platformDomain
        const registeredAssets = assetsProvider.getAssetsForDomain(assetDomain)

        console.log(`JWOStoreManagementPlatform: Loading ${registeredAssets.length} assets from centralized registry`)

        registeredAssets.forEach((asset) => {
            toolRegistry[asset.assetId] = {
                displayName: asset.displayName,
                path: asset.s3AssetLocation.path,
                metadata: {
                    cti: asset.metadata.cti,
                    package: asset.metadata.packageName,
                },
                toolName: asset.assetId,
                icon: getAssetIconUrl(asset),
            }
        })
    } catch (error) {
        console.error('JWOStoreManagementPlatform: Failed to load centralized asset registry:', error)
    }
}

export function getToolById (toolName: string): ITool {
    return _.cloneDeep(toolRegistry[toolName])
}

export function getToolUrl (toolName: string): string {
    let url = _.has(toolRegistry, toolName) ? toolRegistry[toolName].path : ''

    /**
     * For development, uncomment the line below.
     *
     * DO NOT COMMIT THIS!
     */
    url = url.replace('./remote', 'https://ihmpewter.integ.amazon.com/blackrock/remote')

    return url
}
